/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import styled from "@mui/styled-engine-sc";
import FormGroup from "@mui/material/FormGroup";
import React from "react";

const StyledFormGroup = styled(({ ...props }) => <FormGroup {...props} />)`
  ${({ theme }) => `
  `}
`;

export { StyledFormGroup };
